import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { billingExplorerWidgetCostsSelector } from "./billingExplorerWidgetCostsSelector";

export const billingExplorerWidgetTotalCostSelector = createDraftSafeSelector(
  [billingExplorerWidgetCostsSelector],
  (costs) => {
    return costs?.total;
  },
);
